import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { InfobarActions } from './infobar-actions';
import { hasInvert } from './utils';
import { InfobarIcon } from './infobar-icon';
import { InfobarContent } from './infobar-content';
import styles from './styles/infobar.module.css';
import variantsStyles from './styles/infobar-variants.module.css';
import { CloseIcon } from '../icons/close-icon';
import { RegularButton } from '../button/regular-button';
export const InfoBar = /*#__PURE__*/forwardRef(({
  children,
  title,
  icon,
  onClose,
  action,
  secondaryAction,
  className,
  actionsPosition = 'bottom',
  type = 'additional',
  ...props
}, ref) => {
  const classNames = useMemo(() => clsx(styles.infobar, variantsStyles[type], className), [type, className]);
  const needRenderInfobar = title || children;
  const onCloseHandler = () => {
    onClose == null ? void 0 : onClose();
  };
  if (!needRenderInfobar) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames,
    ref: ref,
    "data-testid": "infobar",
    ...props
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(InfobarIcon, {
    icon: icon
  }), /*#__PURE__*/React.createElement(InfobarContent, {
    title: title
  }, children), actionsPosition === 'top' ? (/*#__PURE__*/React.createElement(InfobarActions, {
    invert: hasInvert(type),
    action: action,
    secondaryAction: secondaryAction
  })) : onClose && (/*#__PURE__*/React.createElement(RegularButton, {
    className: styles.close,
    variant: "pseudo",
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    size: "s",
    onClick: onCloseHandler,
    invert: hasInvert(type),
    "data-testid": "infobar-close",
    iconOnly: true,
    rounded: true
  }, /*#__PURE__*/React.createElement(CloseIcon, null)))), actionsPosition === 'bottom' && (/*#__PURE__*/React.createElement(InfobarActions, {
    invert: hasInvert(type),
    action: action,
    secondaryAction: secondaryAction
  })));
});